import styled from "styled-components";
import { useState, useEffect } from "react";
import request from "../../../../api/request";
import FormStringInput from "../../../../components/FormControls/FormStringInput";
import FormCheckBoxWithRightLabel from "../../../../components/FormControls/FormCheckBoxWithRightLabel";
import FormNumberInputNoSpinner from "../../../../components/FormControls/FormNumberInputNoSpinner";
import PrimaryButton from "../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../components/FormControls/SecondaryButton";
import NarrowGrid from "../../../../components/NarrowGrid";
import { NotificationManager } from 'react-notifications';

const StyledMessageLinks = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    min-height: 490px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function MessageLinks(props) {

    const {selectedMessage} = props;

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingMessageLink, setIsDeletingMessageLink] = useState(false);
    const [messageLinks, setMessageLinks] = useState([]);
    const [selectedMessageLink, setSelectedMessageLink] = useState(null);
    const [selectedMessageLinkId, setSelectedMessageLinkId] = useState(null);
    const [isAddMessageLinkMode, setIsAddMessageLinkMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Link description', type: 'String', width: 266, textAlign: 'left'}
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});
    const [linkText, setLinkText] = useState('');
    const [linkURL, setLinkURL] = useState('');
    const [linkPriority, setLinkPriority] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [needsURLValidation, setNeedsURLValidation] = useState(false);
    const [isAddingDuplicatedMessageLink, setIsAddingDuplicatedMessageLink] = useState(false);

    const onSelectGridItem = (item) => {
        setSelectedMessageLinkId(item.Id);
        setSelectedMessageLink(item);
    }
    
    const fetchMessageLinks = async (linkTextToSelect, linkURLToSelect) => {
        try {
            let messageLinkList = [];

            const resp = (await request('database', 'fetchMessageLinks'));
            if (resp.ok) {
                resp.data.map((messageLink, index) => {
                    messageLinkList.push(messageLink);
                });
                setMessageLinks(messageLinkList);
                rebuildGridData(messageLinkList, linkTextToSelect, linkURLToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch message links: ', e);
            return false;
        }
        return true;
    }

    const onDeleteMessageLink = async () => {
        if (selectedMessageLink) {
            setIsDeletingMessageLink(true);
            let deleteData = selectedMessageLink;

            const resp = (await request('database', 'deleteMessageLink', [deleteData]));
            if (resp.ok) {
                setSelectedMessageLink(null);
                setSelectedMessageLinkId(null);
                fetchMessageLinks();
                NotificationManager.success('Successfully deleted message link');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingMessageLink(false);
        }
    }

    const onTestURL = () => {
        if (linkURL === '') {
            setNeedsURLValidation(true);
        } else {
            setNeedsURLValidation(false);
            if (!linkURL.startsWith('https://') && !linkURL.startsWith('http://')) {
                window.open('http://' + linkURL, '_blank');
            } else {
                window.open(linkURL, '_blank');
            }
        }
    }

    const onSaveChanges = async () => {
        if (isAddMessageLinkMode) { // adding new item
            if (linkText === '' || linkURL === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => itm.LinkText === linkText && itm.LinkURL === linkURL && itm.LinkPriority === linkPriority && itm.IsActive === isActive))) {
                    setIsAddingDuplicatedMessageLink(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.MessageId = selectedMessage.MessageId;
                    saveData.LinkText = linkText;
                    saveData.LinkURL = linkURL;
                    saveData.LinkPriority = linkPriority;
                    saveData.IsActive = isActive;

                    const resp = (await request('database', 'createMessageLink', [saveData]));
                    if (resp.ok) {
                        fetchMessageLinks(linkText, linkURL);
                        NotificationManager.success('Successfully added message link');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddMessageLinkMode(false);
                }
            }
        } else {
            if (linkText === '' || linkURL === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (gridData.items[0].length > 0 && (gridData.items[0].find((itm) => (itm.LinkText !== selectedMessageLink.LinkText || itm.LinkURL !== selectedMessageLink.LinkURL || itm.LinkPriority !== selectedMessageLink.LinkPriority || itm.IsActive !== selectedMessage.IsActive) && itm.LinkText === linkText && itm.LinkURL === linkURL && itm.LinkPriority === linkPriority && itm.IsActive === isActive))) {
                    setIsAddingDuplicatedMessageLink(true);
                }
                setIsSaving(true);
                let saveData = {};
                saveData.MessageId = selectedMessage.MessageId;
                saveData.LinkText = linkText;
                saveData.LinkURL = linkURL;
                saveData.LinkPriority = linkPriority;
                saveData.IsActive = isActive;

                saveData.OldLinkText = selectedMessageLink.LinkText;
                saveData.OldLinkURL = selectedMessageLink.LinkURL;
                saveData.OldLinkPriority = selectedMessageLink.LinkPriority;
                saveData.OldIsActive = selectedMessageLink.IsActive;

                const resp = (await request('database', 'updateMessageLink', [saveData]));
                if (resp.ok) {
                    fetchMessageLinks(linkText, linkURL);
                    NotificationManager.success('Successfully updated message link');
                } else
                {
                    console.log(resp.data);
                    NotificationManager.error(resp.data);
                }
                setIsSaving(false);
            }
        }
    }

    const rebuildGridData = (messageLinks, linkTextToSelect, linkURLToSelect) => {
        if (messageLinks && selectedMessage && messageLinks.length > 0) {
            let messageLinkList = [];
            messageLinks.map((messageLink, index) => {
                if (messageLink.MessageId === selectedMessage.MessageId) {
                    let gridItem = {Id: index, 'Link description': messageLink.LinkText, ...messageLink};
                    messageLinkList.push(gridItem);
                    if (linkTextToSelect && linkURLToSelect && messageLink.LinkText === linkTextToSelect && messageLink.LinkURL === linkURLToSelect) {
                        setSelectedMessageLinkId(index);
                        setSelectedMessageLink(gridItem);
                    }
                }
            });
            setGridData({groups: [''], items: [messageLinkList]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchMessageLinks();
            setLoadedPage(true);
        }
        rebuildGridData(messageLinks);
        setSelectedMessageLink(null);
        setSelectedMessageLinkId(null);
        setLinkText('');
        setLinkURL('');
        setLinkPriority(0);
        setIsActive(true);
    }, [selectedMessage]);

    useEffect(() => {
        if (isAddMessageLinkMode) {
            setLinkText('');
            setLinkURL('');
            setLinkPriority(0);
            setIsActive(true);
        } else if (selectedMessageLink) {
            setLinkText(selectedMessageLink.LinkText);
            setLinkURL(selectedMessageLink.LinkURL);
            setLinkPriority(selectedMessageLink.LinkPriority);
            setIsActive(selectedMessage.IsActive);
        }
    }, [isAddMessageLinkMode]);

    useEffect(() => {
        if (selectedMessageLink) {
            setLinkText(selectedMessageLink.LinkText);
            setLinkURL(selectedMessageLink.LinkURL);
            setLinkPriority(selectedMessageLink.LinkPriority);
            setIsActive(selectedMessageLink.IsActive);
        } else {
            setLinkText('');
            setLinkURL('');
            setLinkPriority(0);
            setIsActive(true);
        }
    }, [selectedMessageLink]);

    useEffect(() => {
        setIsAddingDuplicatedMessageLink(false);
        setNeedsValidation(false);
        setNeedsURLValidation(false);
    }, [selectedMessage, selectedMessageLink, isAddMessageLinkMode]);

    return (
        <StyledMessageLinks>
            <WhiteBoard>
                <NarrowGrid id='messagelinks_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddMessageLinkMode || !selectedMessage} itemIdToSelect={selectedMessageLinkId} onSelectGridItem={onSelectGridItem} gridStyle={{width:266, height:130}}></NarrowGrid>
                <div style={{display:'flex', marginTop:10}}>
                    {selectedMessageLinkId !== null && !isAddMessageLinkMode && <SecondaryButton caption='Delete' isLoading={isDeletingMessageLink} onClick={() => onDeleteMessageLink()} style={{width:75, height:25}}></SecondaryButton>}
                    {isAddMessageLinkMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddMessageLinkMode(false)} disabled={!selectedMessage} style={{width:75, height:25, marginLeft:'auto'}}></SecondaryButton>}
                    {!isAddMessageLinkMode && <PrimaryButton caption='Create new' onClick={() => setIsAddMessageLinkMode(true)} disabled={!selectedMessage} style={{width:100, height:25, marginLeft:'auto'}}></PrimaryButton>}
                </div>
                
                <FormStringInput label='Link description' value={linkText} onChange={(val) => setLinkText(val)} disabled={!selectedMessageLink && !isAddMessageLinkMode} validated={needsValidation && linkText === '' ? false : undefined} inputStyle={{width:276}} style={{marginTop:15}}></FormStringInput>
                <FormStringInput label='Link URL' value={linkURL} onChange={(val) => setLinkURL(val)} disabled={!selectedMessageLink && !isAddMessageLinkMode} validated={(needsValidation && linkURL === '') || (needsURLValidation && linkURL === '')? false : undefined} inputStyle={{width:276}}></FormStringInput>
                <div style={{display:'flex'}}>
                    <FormNumberInputNoSpinner label='Priority' value={linkPriority} onChange={(val) => setLinkPriority(val)} disabled={!selectedMessageLink && !isAddMessageLinkMode} inputStyle={{width:135, height:35}}></FormNumberInputNoSpinner>
                    <SecondaryButton caption='Test URL Link' onClick={() => onTestURL()} disabled={!selectedMessageLink && !isAddMessageLinkMode} style={{width:126, marginTop:'auto', marginLeft:15}}></SecondaryButton>
                </div>

                <FormCheckBoxWithRightLabel label='Is active' checked={isActive} disabled={!selectedMessageLink && !isAddMessageLinkMode} onCheck={(val) => setIsActive(val)}></FormCheckBoxWithRightLabel>

                <p style={{fontSize:12, fontWeight:600, color:'#707070', marginTop:20}}>Note</p>
                <p style={{width: 275, fontSize:10, fontWeight:400, color:'#323232', marginTop:15}}>These hyperlinks can be both webpages and documents. The URLs need to be hard coded.<br/><br/>The links will appear at the bottom of the message in accordance with the assigned priority. (Higher numbers will appear first. If 0 is set, the link will appear relative to the time it was added.)</p>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddMessageLinkMode ? 'Add message link' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddMessageLinkMode || selectedMessageLink ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledMessageLinks>
    )
}

export default MessageLinks;